export interface FilterGroup {
  key: string;
  label: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

export default function FilterBar({ groups }: { groups: FilterGroup[] }) {
  return (
    <div className="rounded-lg border border-background-200/80 bg-background-50 p-4 md:p-5">
      {groups.map((group, index) => (
        <div
          key={group.key}
          className={`flex flex-col gap-2 py-3 md:flex-row md:items-center md:gap-4 ${
            index !== groups.length - 1 ? "border-b border-background-200/70" : ""
          }`}
        >
          <span className="w-16 shrink-0 font-label text-sm font-medium text-foreground-500">
            {group.label}
          </span>
          <div className="flex flex-wrap gap-2">
            {group.options.map((option) => (
              <button
                key={option}
                type="button"
                onClick={() => group.onChange(option)}
                className={`whitespace-nowrap rounded-full px-3 py-1.5 font-label text-sm transition-colors ${
                  group.value === option
                    ? "bg-primary-500 text-background-50"
                    : "bg-background-100 text-foreground-700 hover:bg-background-200"
                }`}
              >
                {option}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}